import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { draggable, dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classes from 'components/Bookings2/Navbar/Navbar.module.scss';
import { BookingTab, BookingTabId } from 'components/Bookings2/Navbar/bookingTabs';
import React, { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';

interface BookingTabItemProps {
    tab: BookingTab;
    // eslint-disable-next-line no-unused-vars
    onMove: (sourceId: BookingTabId, targetId: BookingTabId) => void;
    onDrop: () => void;
}

export const BookingTabItem: React.FC<BookingTabItemProps> = ({ tab, onMove, onDrop }) => {
    const elementRef = useRef<HTMLAnchorElement>(null);
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        return combine(
            draggable({
                element,
                getInitialData: () => ({ type: 'booking-tab', tabId: tab.id }),
                onDragStart: () => setIsDragging(true),
                onDrop: () => {
                    setIsDragging(false);
                    onDrop();
                }
            }),
            dropTargetForElements({
                element,
                canDrop: ({ source }) => source.data.type === 'booking-tab',
                getData: () => ({ type: 'booking-tab', tabId: tab.id }),
                onDragEnter: ({ source }) => {
                    const sourceId = source.data.tabId as BookingTabId;
                    if (sourceId !== tab.id) onMove(sourceId, tab.id);
                }
            })
        );
    }, [onDrop, onMove, tab.id]);

    return (
        <NavLink
            to={tab.path}
            className={`${classes.menuLink} ${isDragging ? classes.dragging : ''}`}
            isActive={tab.isActive}
            ref={elementRef}
        >
            <FontAwesomeIcon icon={tab.icon} />
            {tab.label}
        </NavLink>
    );
};
